import PropTypes from "prop-types";
import SubscribeBlock from "../../subscribe-block";


const SubscribeCtaBlog = (props: { title: string }) => {
    return <>
        <section className={`call-to-action-customer subscribe-cta-resources`}>
            <div className={"in-block"}>
                <h2>{props.title}</h2>
                <SubscribeBlock/>
            </div>
        </section>
    </>
}
SubscribeCtaBlog.defaultProps = {
    title: "Never Miss an Event & Get Resources Delivered Straight to Your Inbox",
}

SubscribeCtaBlog.propTypes = {
    title:PropTypes.string,
}
export default SubscribeCtaBlog
